namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoItem2Form {
        PmGroupId: Serenity.StringEditor;
        PmId: Serenity.StringEditor;
        PmType: Serenity.IntegerEditor;
        PmExtCode: Serenity.StringEditor;
        PmStepNo: Serenity.IntegerEditor;
        PmDesc: Serenity.StringEditor;
        PmOrder: Serenity.IntegerEditor;
        LineItemNo: Serenity.IntegerEditor;
        ItemType: Serenity.EnumEditor;
        Qty: Serenity.DecimalEditor;
        FreeLpFg: Serenity.RadioButtonEditor;
        NpcsOrBundlePrice: Serenity.DecimalEditor;
        DiscPc: Serenity.DecimalEditor;
        DiscAmt: Serenity.DecimalEditor;
        AssortFg: Serenity.RadioButtonEditor;
        ListFg: Serenity.RadioButtonEditor;
        PluCode: Serenity.LookupEditor;
        StyleCode: Serenity.LookupEditor;
        BrandCode: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        SupplCode: Serenity.LookupEditor;
    }

    export class PsAdvPromoItem2Form extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsAdvPromoItem2';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsAdvPromoItem2Form.init)  {
                PsAdvPromoItem2Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.EnumEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.RadioButtonEditor;
                var w5 = s.LookupEditor;

                Q.initFormType(PsAdvPromoItem2Form, [
                    'PmGroupId', w0,
                    'PmId', w0,
                    'PmType', w1,
                    'PmExtCode', w0,
                    'PmStepNo', w1,
                    'PmDesc', w0,
                    'PmOrder', w1,
                    'LineItemNo', w1,
                    'ItemType', w2,
                    'Qty', w3,
                    'FreeLpFg', w4,
                    'NpcsOrBundlePrice', w3,
                    'DiscPc', w3,
                    'DiscAmt', w3,
                    'AssortFg', w4,
                    'ListFg', w4,
                    'PluCode', w5,
                    'StyleCode', w5,
                    'BrandCode', w5,
                    'CatCode', w5,
                    'SubCat1Code', w5,
                    'SubCat2Code', w5,
                    'SupplCode', w5
                ]);
            }
        }
    }
}
